export enum LocalStorageKeys {
  CenterInfo = "CenterInfo",
  LastActivityAt = "LastActivityAt",
  SESSION_KEY = 'analytics_session_id',

}
